import InAppMessage from "./in-app-message.js";
import { DOMUtils as Ie } from "../../util/dom-utils.js";
export default class SlideUpMessage extends InAppMessage {
  constructor(
    e,
    t,
    s,
    o,
    i,
    r,
    n,
    d,
    a,
    u,
    p,
    m,
    c,
    l,
    v,
    x,
    f,
    h,
    g,
    I,
    M,
    b,
    j,
    z,
  ) {
    (x = x || InAppMessage.th.Rh),
      (v = v || InAppMessage.th.Nh),
      super(
        e,
        (t = t || InAppMessage.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
        b,
        j,
        z,
      ),
      (this.Io = InAppMessage.TextAlignment.START);
  }
  zo() {
    return !1;
  }
  No() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    Ie.td(t, !0, !0) ||
      (this.slideFrom === InAppMessage.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.ah(e);
  }
  gt() {
    return super.gt(SlideUpMessage.es);
  }
  static Zn(e) {
    return new SlideUpMessage(
      e[InAppMessage.ss.pa],
      e[InAppMessage.ss.ma],
      e[InAppMessage.ss._h],
      e[InAppMessage.ss.xs],
      e[InAppMessage.ss.ua],
      e[InAppMessage.ss.ca],
      e[InAppMessage.ss.URI],
      e[InAppMessage.ss.fa],
      e[InAppMessage.ss.da],
      e[InAppMessage.ss.la],
      e[InAppMessage.ss.ga],
      e[InAppMessage.ss.ns],
      e[InAppMessage.ss.xa],
      e[InAppMessage.ss.za],
      e[InAppMessage.ss.ha],
      e[InAppMessage.ss.va],
      e[InAppMessage.ss.wa],
      e[InAppMessage.ss.ya],
      e[InAppMessage.ss.Sa],
      e[InAppMessage.ss.Ea],
      e[InAppMessage.ss.CSS],
      e[InAppMessage.ss.Fa],
      e[InAppMessage.ss.LANGUAGE],
      e[InAppMessage.ss.ks],
    );
  }
}
SlideUpMessage.es = InAppMessage.Eo.ia;
